export default "__VITE_ASSET__Cw968R5K__"